import { createSlice } from '@reduxjs/toolkit'
import image1 from './../../../assets/images/event/evento-1.jpg'
import image2 from './../../../assets/images/event/evento-2.jpg'
import image3 from './../../../assets/images/event/evento-3.jpg'
import image4 from './../../../assets/images/event/evento-4.jpg'
import image5 from './../../../assets/images/event/evento-5.jpg'
import image6 from './../../../assets/images/event/evento-6.jpg'

export const eventSlice = createSlice({
    name: 'events',
    initialState: {
        eventsArray: [
            {
                id: 0,
                tittle: 'Primer evento',
                description: 'Text buttons are typically used for less-pronounced actions, including those located: in dialogs, in cards. In cards, text buttons help maintain an emphasis on card content.',
                image: image1
            },
            {
                id: 1,
                tittle: 'Segundo evento',
                description: 'Text buttons are typically used for less-pronounced actions, including those located: in dialogs, in cards. In cards, text buttons help maintain an emphasis on card content.',
                image: image3
            },
            {
                id: 2,
                tittle: 'Tercer evento',
                description: 'Text buttons are typically used for less-pronounced actions, including those located: in dialogs, in cards. In cards, text buttons help maintain an emphasis on card content.',
                image: image4
            },
            {
                id: 3,
                tittle: 'Cuarto evento',
                description: 'Text buttons are typically used for less-pronounced actions, including those located: in dialogs, in cards. In cards, text buttons help maintain an emphasis on card content.',
                image: image5
            },
            {
                id: 4,
                tittle: 'Quinto evento',
                description: 'Text buttons are typically used for less-pronounced actions, including those located: in dialogs, in cards. In cards, text buttons help maintain an emphasis on card content.',
                image: image6
            },
            {
                id: 5,
                tittle: 'Sexto evento',
                description: 'Text buttons are typically used for less-pronounced actions, including those located: in dialogs, in cards. In cards, text buttons help maintain an emphasis on card content.',
                image: image2
            },
            {
                id: 6,
                tittle: 'Septimo evento',
                description: 'Text buttons are typically used for less-pronounced actions, including those located: in dialogs, in cards. In cards, text buttons help maintain an emphasis on card content.',
                image: image2
            },
            {
                id: 7,
                tittle: 'Octavo evento',
                description: 'Text buttons are typically used for less-pronounced actions, including those located: in dialogs, in cards. In cards, text buttons help maintain an emphasis on card content.',
                image: image2
            }
        ],
        ordenes: [
            {
                id: '741258',
                amount: '$25,921.00',
                status: 'Depositado',
                buyer: 'Jorge Colmenero'
            },
            {
                id: '258741',
                amount: '$56,789.00',
                status: 'Pagado',
                buyer: 'Juquin Cosio'
            },
            {
                id: '258742',
                amount: '$56,789.00',
                status: 'Depositado',
                buyer: 'Juquin Cosio'
            },
            {
                id: '258743',
                amount: '$56,789.00',
                status: 'Depositado',
                buyer: 'Juquin Cosio'
            },
            {
                id: '258744',
                amount: '$56,789.00',
                status: 'Pagado',
                buyer: 'Juquin Cosio'
            },
            {
                id: '258745',
                amount: '$56,789.00',
                status: 'Pagado',
                buyer: 'Juquin Cosio'
            },
            {
                id: '258746',
                amount: '$56,789.00',
                status: 'Pagado',
                buyer: 'Juquin Cosio'
            },
            {
                id: '258747',
                amount: '$56,789.00',
                status: 'Pagado',
                buyer: 'Juquin Cosio'
            },
            {
                id: '258748',
                amount: '$56,789.00',
                status: 'Depositado',
                buyer: 'Juquin Cosio'
            },
            {
                id: '258749',
                amount: '$56,789.00',
                status: 'Pagado',
                buyer: 'Juquin Cosio'
            },
        ]
    },
    reducers: {
        setEventList: (state, action) => {
            state.eventsArray = action.payload
        }
    }
})

export const { setEventList } = eventSlice.actions
export default eventSlice.reducer